import { CommonsV1ApiBase } from './base';
import { CourseStatIndexView } from '../types/courseStats';

export const CourseStatApi = {
  base() {
    return CommonsV1ApiBase.appendPath('users/current/course_stats');
  },
  index(): Promise<CourseStatIndexView[]> {
    return this.base().get();
  },
};
